<template>
    <div class="qr-container">
        <vue-title :title="title" :brand="true"></vue-title>
        <video ref="qrFeed">

        </video>

        <div class="qr-overlay">

        </div>

        <div class="qr-scan-success"
             :class="{'fade-out': scanSuccessCheckFading}"
             v-if="showScanSuccessCheck"
             aria-hidden="true">
            <div class="qr-scan-success-check">

            </div>
        </div>

        <div class="qr-tools">
            <div class="button-group">
                <button :class="{'active': mode == 'scanner'}"
                        @click="mode = 'scanner'">
                    Scan
                </button>
                <button :class="{'active': mode == 'check'}"
                        @click="mode = 'check'">
                    Check
                </button>
                <button @click="switchToLeadMode">
                    Scan List
                </button>
            </div>
        </div>

        <div class="qr-session-selector-modal" v-if="showSessionSelector">
            <div class="qr-session-selector">
                <h4>
                    Select Session (Now: {{$filters.moment(referenceTime, 'h:mm a')}})<br>
                    <span class="current-selection-indicator" v-if="selectedSession">Current selection: <span class="fw-bold">{{ $filters.moment(selectedSession.SessionStartDateTime, 'MMM D h:mm a')}} - {{ $filters.moment(selectedSession.SessionEndDateTime, 'h:mm a')}}</span>: {{selectedSession.Name}}</span>
                </h4>

                <div class="session-select"
                        v-for="session in sessionList"
                        :class="{'selected': session.Code == selectedSessionCode, 'past': session.IsInPast, 'future': session.IsInFuture, 'hint': session.IsCurrent}"
                        @click="selectedSessionCode = session.Code; showSessionSelector = false">

                    <h5>
                        {{ session.Name }}<!--<br>P:{{session.IsInPast}} F:{{session.IsInFuture}} C:{{session.IsCurrent}}-->
                    </h5>
                    <h6>
                        {{ $filters.moment(session.StartDateTime, 'MMM D h:mm a')}} - {{$filters.moment(session.EndDateTime, 'h:mm a')}}

                        <span class="fw-bold" v-if="session.IsInPast">⚠️ Past session</span>
                        <span class="fw-bold" v-if="session.IsInFuture">🕑 Future session</span>
                    </h6>
                </div>
            </div>
        </div>

        <div class="qr-bottom-tools">
            <button type="button" class="session-select-btn" @click="showSessionSelector = true">
                <span v-if="!selectedSession">
                    (Select a session)
                </span>
                <span v-else>
                    <span class="fw-bold">{{ $filters.moment(selectedSession.SessionStartDateTime, 'MMM D h:mm a')}} - {{ $filters.moment(selectedSession.SessionEndDateTime, 'h:mm a')}}</span>: {{selectedSession.Name}}
                </span>
            </button>

            <div class="button-group"
                 v-if="requiresTwoScans">
                <button :class="{'active': scanMode == 'CheckIn'}"
                        @click="scanMode = 'CheckIn'">
                    In
                </button>
                <button :class="{'active': scanMode == 'CheckOut'}"
                        @click="scanMode = 'CheckOut'">
                    Out
                </button>
            </div>            
        </div>

        <div class="qr-loading"
             v-show="submitting">
            <loading>

            </loading>
        </div>

        <div class="qr-check"
             v-if="qrCheckResults">
            
            <div class="qr-check-results">
                <h4>{{ qrCheckResults.Title }}</h4>
                <h5 v-if="qrCheckResults.CheckInTime">
                    ✅ Checked in at {{ qrCheckResults.CheckInTime }}.
                </h5>
                <h5 v-else>
                    ❌ No Check In Scan Recorded
                </h5>
                <h5 v-if="qrCheckResults.CheckOutTime && requiresTwoScans">
                    ✅ Checked out at {{ qrCheckResults.CheckOutTime }}.
                </h5>
                <h5 v-else-if="!qrCheckResults.CheckOutTime && requiresTwoScans">
                    ❌ No Check Out Scan Recorded
                </h5>
                <button @click="qrCheckResults = null">
                    Close
                </button>
            </div>
        </div>

        <div class="search-box-overlay"
             v-if="mode == 'leads'">
            <div class="search-box">
                <span class="icomoon">
                    
                </span>
                <input placeholder="Search" 
                       v-model="searchText"
                    ref="searchInput"
                    type="text"/>
            </div>
        </div>

        <div v-if="mode == 'leads'"
                class="lead-list">
                <div class="header-actions">
                    <span class="scan-total">
                        Total scans: {{ leads.length }}
                    </span>
                    <select class="form-select"
                            v-model="selectedSessionCode">
                        <optgroup v-for="sessionGroup in sessionGroups" 
                                :label="sessionGroup.Name"
                                :key="sessionGroup.Code">
                            <option v-for="session in sessionGroup.Sessions" 
                                    :value="session.Code"
                                    :key="session.Code">
                                {{ $filters.moment(session.StartDateTime, 'MMM DD h:mm a')}} - {{session.Name}} ({{ session.Duration }})
                            </option>
                        </optgroup>
                    </select>                
                    <div class="actions">
                        <button class="icomoon" @click="exportToCsv">
                            
                        </button>
                        <button class="icomoon" @click="switchToScanMode">
                            
                        </button>
                    </div>
                </div>

                <div class="item-list">
                    <div v-if="leads.length == 0">
                        No scans recorded.
                    </div>
                    <div v-for="item in filteredLeads"
                        :key="item.AttendeeCode"
                        class="favorite-list-item list-item scan-list-item"
                        @click="checkSessionScan(showCode, item.AttendeeCode)">
                        <div>
                            <img-g :src="`${getApiUrl()}/api/asset/${showCode}/attendee/${item.AttendeeCode}/profile`"
                                    class="round-photo"
                                fallbackSrc="/img/person.png" />
                            <div>
                                <span class="title">
                                    {{item.Attendee.DisplayName}}
                                </span>
                                <span class="subtitle"
                                        v-if="item.Attendee.Title">
                                    {{item.Attendee.Title}}
                                </span>
                                <span class="subtitle"
                                        v-if="item.Attendee.SubTitle">
                                    {{item.Attendee.SubTitle}}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="!mode"
                class="launch-page">
                <button @click="switchToScanMode">
                    Scan Badges
                </button>
                <button @click="switchToLeadMode">
                    View Scans
                </button>
            </div>        

        <div class="qr-loading qr-error"
             v-show="error">
            <span>
                {{ error }}
            </span>

            <button @click="getSessions()">
                Retry
            </button>
        </div>
    </div>
</template>
<script>
import QrScanner from 'qr-scanner'; 
import moment from 'moment'
import { AppState } from './appstate';
import Token from './authentication/token'
import Common from './common'
import { nextTick } from '@vue/runtime-core';
import { parseAttendeeBadgeScan } from './scan.helpers';


export default {
    props: ['sectionCode'],
    mixins: [
        Token,
        Common
    ],   

    data() {
        return {
            sessionGroups: [],
            sessions: [],

            selectedSessionCode: null,
            mode: '',

            submitting: false,
            scanMode: "CheckIn",
            scanner: null,
            lastScannedText: null,
            showLastScannedText: false,
            scanStatus:"",
            showScanSuccessCheck: false,
            scanSuccessCheckFading: false,
            scanSuccessCheckTimer: null,
            error: null,
            qrCheckResults: null,
            leads: [],
            searchText: '',
            agenda: {},

            showSessionSelector: false,

            referenceTime: new Date(),
            referenceTimeWatchdog: null,
        }
    },

    computed: {
        title() {
            return AppState.show.Sections[this.sectionCode].Title;
        },
        requiresTwoScans() {
            return AppState.show.Sections[this.sectionCode].Settings?.Mode == "TwoScan"
                || !AppState.show.Sections[this.sectionCode].Settings;
        },
        showCode() {
            return AppState.showCode;
        },

        selectedSession() {
            return this.selectedSessionCode
                ? this.sessions.find(x => x.Code == this.selectedSessionCode)
                : null
        },

        filteredLeads() {
            let leads = this.leads;

            if(!this.searchText) {
                return leads;
            }

            let toReturn = Array.from(this.leads);

            if(this.searchText && this.searchText.length > 0) {
                let searchTest = new RegExp(this.searchText, 'i');

                toReturn = toReturn.filter(x => {

                    return searchTest.test(x.Attendee.DisplayName);

                });
            }

            return toReturn;
        },

        sessionList() {
            if(!this.sessions) {
                return [];
            }

            let toReturn = [];

            toReturn = this.sessions.map(sessionModel => {
                let s = sessionModel;
                let startTimeCompare = moment(s.SessionStartDateTime).diff(moment(this.referenceTime), 'minutes')
                let endTimeCompare = moment(s.SessionEndDateTime).diff(moment(this.referenceTime), 'minutes')
                let isCurrent = startTimeCompare <= 15 && endTimeCompare > -5;

                return {
                    Code: s.Code,
                    CategoryCode: s.Category?.Code,
                    Name: s.Name,
                    StartDateTime: s.SessionStartDateTime,
                    EndDateTime: s.SessionEndDateTime,
                    Location: s.Location || '(No Room Set)',
                    Duration: `${moment(s.SessionEndDateTime).diff(moment(s.SessionStartDateTime), 'minutes')} minutes`,
                    IsInPast: !isCurrent && moment(s.SessionEndDateTime).diff(moment(this.referenceTime), 'minutes') < 0,
                    IsInFuture: !isCurrent && moment(s.SessionStartDateTime).diff(moment(this.referenceTime), 'minutes') > 0,
                    IsCurrent: isCurrent
                }; 
            });

            toReturn.sort((a, b) => {
                    // First, move the selected session to the very top.
                    if (a.Code === this.selectedSessionCode) return -1;
                    if (b.Code === this.selectedSessionCode) return 1;

                    // Define a function that returns a group number for each session.
                    // Lower group numbers will be sorted to the top.
                    const getGroup = session => {
                        if (session.IsCurrent) {
                            return 1;
                        } else if (session.IsInFuture) {
                            return 2;
                        } else if (session.IsInPast) {
                            return 3;
                        }
                        return 4; // Fallback in case a session does not match any category.
                    };

                    const groupA = getGroup(a);
                    const groupB = getGroup(b);
                    
                    // Compare the groups first.
                    if (groupA !== groupB) return groupA - groupB;

                    // If the sessions belong to the same group,
                    // sort them by their start time (ascending order).
                    return moment(a.StartDateTime).diff(moment(b.StartDateTime));
                });

            return toReturn;

        },
    },

    watch: {
        scanMode() {
            this.lastScannedText = null;
            this.scanStatus = "";
        },

        selectedSessionCode(newValue, oldValue){
            this.lastScannedText = null;
            this.scanStatus = "";

            if(this.selectedSessionCode
                && localStorage) {
                
                localStorage.setItem("SELECTED_SESSION", this.selectedSessionCode);
            }

            if(oldValue) {
                try {
                    window.$signalRConnection.invoke(
                        'UnregisterForPageAnalytics', 
                        `${AppState.showCode}_${oldValue}_LEADS`.toUpperCase());
                } catch {

                }
            }

            if(this.mode == 'leads') {
                this.reloadLeads();
            }

        },

        mode(){
            this.lastScannedText = null;
            this.scanStatus = "";
        }
    },

    methods: {
        switchToLeadMode() {
            if(this.scanner) {
                this.scanner.stop();
                this.scanner = null;
            }

            this.mode = 'leads';

            this.connectToControlChannel();

            this.reloadLeads();
        },

        switchToScanMode() {
            this.mode = 'scanner'
            this.scanner = new QrScanner(
            this.$refs.qrFeed,
            this.onScanSuccess,
            {
                highlightCodeOutline: true,
                highlightScanRegion: true,
                preferredCamera: 'environment',
                maxScansPerSecond: 5
            });

            this.scanner.start();    

            window.$signalRConnection.invoke(
                'UnregisterForPageAnalytics', 
                `${AppState.showCode}_${this.selectedSessionCode}_LEADS`.toUpperCase());
        },

        async reloadLeads() {
            this.submitting = true;

            try {
                let result = await this.tryGet(`/api/scans/${this.showCode}/check/session/${this.selectedSessionCode}`);
                this.leads = result.Result || [];
            } catch {
                this.$awn.alert("Could not reload the scan list.");
            }

            this.submitting = false;
        },

        async connectToControlChannel(){
            if(window.$signalRConnection.notInitialized) {
                return;
            }

            if(!this.selectedSessionCode) {
                return;
            }

            if(this.mode != 'leads') {
                return;
            }

            window.$signalRConnection.invoke(
                'RegisterForPageAnalytics', 
                `${AppState.showCode}_${this.selectedSessionCode}_LEADS`.toUpperCase());
        },

        async testScanSuccess(){
            await this.onScanSuccess({
                "data": "tractus://"
            });
        },

        async getSessions(){
            this.error = null;

            this.sessions = [];
            this.sessionGroups = [];
            this.submitting = true;

            let section = AppState.show.Sections[this.sectionCode];
            let allSessionCategories = AppState.show.SessionCategories || [];

            var showCategories = [];
            var sectionCategories = section.Categories && section.Categories.length > 0
                ? section.Categories
                : allSessionCategories;

            for(var i = 0; i < sectionCategories.length; i++){
                var sessionCategory = allSessionCategories.filter( n => sectionCategories[i].Code == n.Code);

                if( sessionCategory.length > 0){
                    showCategories.push(sessionCategory[0]);
                }
            }

            let categoryQuery = showCategories.map(x => x.Code).join(';');
            let path = `/api/sessions/${AppState.show.Code}/agenda`;

            if(categoryQuery) {
                path = `${path}?c=${encodeURIComponent(categoryQuery)}`;
            }

            let result = await this.tryGet(path)

            if(!result || result.Errors?.length > 0 || !result.Result) {
                this.error = "Could not load sessions for scanning.";
                this.submitting = false;
                return;
            }

            this.agenda = result.Result;

            this.sessions = [...(this.agenda.Sessions || []).map(x => x.Session).filter(x => x)];
            this.sessionGroups = this.buildSessionGroups();

            if(this.sessions.length == 0) {
                this.error = "No sessions are available for scanning.";
                this.submitting = false;
                return;
            }

            if(localStorage) {
                let lastSession = localStorage.getItem("SELECTED_SESSION");

                if(lastSession && this.sessions.some(x => x.Code == lastSession)) {
                    this.selectedSessionCode = lastSession;
                }
            }

            if(!this.selectedSessionCode && this.sessionList.length > 0) {
                this.selectedSessionCode = this.sessionList[0].Code;
            }

            this.submitting = false;
            this.showSessionSelector = true;
            this.onReferenceTimeWatchdog();

            nextTick(() => {
                this.switchToScanMode();
            });
        },

        buildSessionGroups() {
            let categories = this.agenda.Categories && this.agenda.Categories.length > 0
                ? this.agenda.Categories
                : this.sessions
                    .map(x => x.Category)
                    .filter((category, index, categories) =>
                        category && categories.findIndex(x => x.Code == category.Code) == index);

            return categories
                .map(category => {
                    return {
                        Code: category.Code,
                        Name: category.Name,
                        Sessions: this.sessionList.filter(x => x.CategoryCode == category.Code)
                    };
                })
                .filter(x => x.Sessions.length > 0);
        },

        async saveSessionScan(showCode, attendeeCode) {
            let scannedByAttendeeCode = AppState.attendeeCode;
           
            let scanDateTime = moment();
            let sessionCode = this.selectedSessionCode;

            let toSave = {
                'ShowCode': showCode,
                'AttendeeCode': attendeeCode,
                'ScannedByAttendeeCode': scannedByAttendeeCode,
                'ScanDateTime': scanDateTime,
                'SessionCode': sessionCode,
                'Mode': this.scanMode
            };

            try{
                let result = await this.tryPost('/api/scan/session', JSON.stringify(toSave), 'application/json');

                if(result && result.Result) {
                    this.showScanSuccess();
                } else {
                    this.$awn.alert("Scan not saved. Please try again.");
                }
            } catch(ex){
                this.$awn.alert("Scan not saved. Please try again.");
            }
        },

        showScanSuccess() {
            if(this.scanSuccessCheckTimer) {
                clearTimeout(this.scanSuccessCheckTimer);
                this.scanSuccessCheckTimer = null;
            }

            this.showScanSuccessCheck = true;
            this.scanSuccessCheckFading = false;

            this.playScanSuccessBeep();

            this.scanSuccessCheckTimer = setTimeout(() => {
                this.scanSuccessCheckFading = true;

                this.scanSuccessCheckTimer = setTimeout(() => {
                    this.showScanSuccessCheck = false;
                    this.scanSuccessCheckFading = false;
                    this.scanSuccessCheckTimer = null;
                }, 250);
            }, 600);
        },

        playScanSuccessBeep() {
            try {
                const AudioContext = window.AudioContext || window.webkitAudioContext;

                if(!AudioContext) {
                    return;
                }

                const audioContext = new AudioContext();
                const oscillator = audioContext.createOscillator();
                const gain = audioContext.createGain();

                oscillator.type = 'sine';
                oscillator.frequency.setValueAtTime(880, audioContext.currentTime);
                gain.gain.setValueAtTime(0.08, audioContext.currentTime);
                gain.gain.exponentialRampToValueAtTime(0.001, audioContext.currentTime + 0.08);

                oscillator.connect(gain);
                gain.connect(audioContext.destination);
                oscillator.start();
                oscillator.stop(audioContext.currentTime + 0.08);
                oscillator.onended = () => audioContext.close();
            } catch {

            }
        },

        async checkSessionScan(showCode, attendeeCode) {
            // Query the API to get the scan history for the attendee
            this.submitting = true;
            this.qrCheckResults = null;

            let sessionCode = this.selectedSessionCode;

            try {
                let result = await this.tryGet(`/api/scans/${showCode}/${attendeeCode}/check/session/${sessionCode}`)

                let qrCheckResults = {
                    Title: '❌ Not Checked In',
                    Scans: [],
                    CheckInTime: null,
                    CheckOutTime: null,
                    CheckIns: [],
                    CheckOuts: [],
                };

                let earliestCheckIn = result.Result.find(e => e.Mode == 'CheckIn');
                let earliestCheckOut = result.Result.find(e => e.Mode == 'CheckOut');

                qrCheckResults.CheckInTime = earliestCheckIn ? moment(earliestCheckIn.ScanDateTime).format('MMM DD h:mm a') : null;
                qrCheckResults.CheckOutTime = earliestCheckOut ? moment(earliestCheckOut.ScanDateTime).format('MMM DD h:mm a') : null;

                qrCheckResults.CheckIns = result.Result.filter(e => e.Mode == "CheckIn");
                qrCheckResults.CheckOuts = result.Result.filter(e => e.Mode == "CheckOut");

                if(!earliestCheckIn && earliestCheckOut) {
                    qrCheckResults.Title = "⚠️ Checked Out, Not Checked In"
                }

                if(earliestCheckIn && !earliestCheckOut) {
                    qrCheckResults.Title = "⚠️ Checked In, Not Checked Out"
                }

                if(earliestCheckIn && earliestCheckOut) {
                    qrCheckResults.Title = "✅ Checked Out"
                }

                if(!this.requiresTwoScans && earliestCheckIn) {
                    qrCheckResults.Title = "✅ Checked In";
                }

                this.qrCheckResults = qrCheckResults;
            } catch(ex) {
                console.log(ex);
                this.$awn.alert("Could not retrieve scan results. Please try again later.");
            }

            this.submitting = false;
        },

        async onScanSuccess(result) {

            if(!this.selectedSessionCode){
                this.$awn.alert("No Session Selected")
                return;
            }

            if(this.lastScannedText == result.data) {
                this.scanStatus = "Successfully Scanned";
                return;
            }

            this.scanStatus = "";

            this.lastScannedText = result.data;

            let attendeeBadge = parseAttendeeBadgeScan(this.lastScannedText);

            if(attendeeBadge) {
                let attendeeCode = attendeeBadge.attendeeCode;
                let showCode = attendeeBadge.showCode;

                if(showCode != AppState.showCode) {
                    this.$awn.alert("This badge is not for this show.");
                    this.submitting = false;
                    return;
                }
                if(this.mode == 'scanner') {
                    await this.saveSessionScan(showCode, attendeeCode);
                } else if (this.mode == 'check') {
                    await this.checkSessionScan(showCode, attendeeCode);
                }

            } else {
                this.$awn.alert("Sorry. QR code not recognized.");
            }
            

        },

        onLeadCaptured(lead) {
            if(!lead) {
                return;
            }

            if(lead.SessionCode != this.selectedSessionCode) {
                return;
            }

            let existingLead = this.leads.find(x => x.AttendeeCode == lead.AttendeeCode);

            if(!existingLead) {
                this.leads.push(lead);
            } else {
                Object.assign(existingLead, lead);
            }
        },

        onReferenceTimeWatchdog() {
            if(this.$route.query.dtt) {
                this.referenceTime = new Date(this.$route.query.dtt);
            } else {
                this.referenceTime = new Date();
            }
        }

    },

    beforeUnmount() {
        if(this.referenceTimeWatchdog) {
            clearInterval(this.referenceTimeWatchdog);
            this.referenceTimeWatchdog = null;
        }

        if(this.scanSuccessCheckTimer) {
            clearTimeout(this.scanSuccessCheckTimer);
            this.scanSuccessCheckTimer = null;
        }

        window.$bus.$off('connected-to-signalr', this.connectToControlChannel);       
        window.$bus.$off('LeadCaptured', this.onLeadCaptured);    

        if(this.scanner) {
            this.scanner.stop();
        }

        window.$signalRConnection.invoke(
            'UnregisterForPageAnalytics', 
            `${AppState.showCode}_${this.selectedSessionCode}_LEADS`.toUpperCase());

    },

    async mounted() {
        window.$bus.$on('connected-to-signalr', this.connectToControlChannel);
        window.$bus.$on('LeadCaptured', this.onLeadCaptured);
        this.referenceTimeWatchdog = setInterval(this.onReferenceTimeWatchdog, 10000);
        await this.getSessions();
    }

}
</script>
